export default "__VITE_ASSET__DPLe4EUX__"